<template>
  <div class="kiosk-view">
    <router-view />
  </div>
</template>
<script>


export default {
  name: 'KioskView',
  components: {
   // HelloWorld,
  },
  data() {
    return {

    }
  },
computed: {

},
  methods: {

  }
}
</script>
<style>

</style>
